module.exports = __webpack_public_path__ + "img/strip.878fbbcf.svg";